var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 10C10.9206 10 11.6667 9.25381 11.6667 8.33333C11.6667 7.41286 10.9206 6.66667 10.0001 6.66667C9.07961 6.66667 8.33341 7.41286 8.33341 8.33333C8.33341 9.25381 9.07961 10 10.0001 10ZM10.0001 10C8.15913 10 6.66675 11.4924 6.66675 13.3333M10.0001 10C11.841 10 13.3334 11.4924 13.3334 13.3333M9.16675 2.5H10.8334C14.9756 2.5 18.3334 5.85786 18.3334 10C18.3334 14.1421 14.9756 17.5 10.8334 17.5H5.00008C3.15913 17.5 1.66675 16.0076 1.66675 14.1667V10C1.66675 5.85786 5.02461 2.5 9.16675 2.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutline);
export default __webpack_public_path__ + "static/media/chat-outline.b6ee74b25304bc98893c7c64f4aa52d7.svg";
export { ForwardRef as ReactComponent };